import React, { useState, useRef, useCallback } from "react";

export function PullToRefresh({
  onRefresh,
  children,
}: {
  onRefresh: () => Promise<void>;
  children: React.ReactNode;
}) {
  const [pulling, setPulling] = useState(false);
  const [offset, setOffset] = useState(0);
  const startY = useRef(0);
  const threshold = 80;

  const onTouchStart = useCallback((e: React.TouchEvent) => {
    if (window.scrollY === 0) {
      startY.current = e.touches[0].clientY;
    }
  }, []);

  const onTouchMove = useCallback((e: React.TouchEvent) => {
    if (window.scrollY > 0 || startY.current === 0) return;
    const dy = e.touches[0].clientY - startY.current;
    if (dy > 0) {
      e.preventDefault();
      setPulling(true);
      setOffset(Math.min(dy * 0.5, threshold + 20));
    }
  }, []);

  const onTouchEnd = useCallback(() => {
    if (offset >= threshold) {
      onRefresh().finally(() => {
        setPulling(false);
        setOffset(0);
        startY.current = 0;
      });
    } else {
      setPulling(false);
      setOffset(0);
      startY.current = 0;
    }
  }, [offset, onRefresh]);

  return (
    <div
      onTouchStart={onTouchStart}
      onTouchMove={onTouchMove}
      onTouchEnd={onTouchEnd}
      style={{ touchAction: "pan-y" }}
    >
      {pulling && (
        <div
          style={{
            height: offset,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <span
            className="spinner"
            style={{
              width: 20,
              height: 20,
              border: "2px solid hsl(var(--c-border))",
              borderTopColor: "hsl(var(--c-primary))",
              borderRadius: "50%",
              animation: "spin 0.8s linear infinite",
              display: "inline-block",
            }}
          />
        </div>
      )}
      {children}
    </div>
  );
}
